<template>
  <div class="vuse-content-wrapper contact-app">
    <div v-if="hasAccess('userGroup')">
    <vuse-section-definition :title="page" icon="supervised_user_circle" />
    <v-container fluid class="">
      <v-row>
        <v-col cols="12" lg="4" md="6">
          <v-card>
            <v-card-title>
              <div>Group Name</div>
              <v-spacer></v-spacer>
              <v-btn color="info" @click="onAdd()" x-small fab rounded v-show="hasAccess('userGroup.add')"
                ><v-icon small>add</v-icon></v-btn
              >
            </v-card-title>
            <v-card-text style="max-height: 30vw; overflow: auto">
              <v-list>
                <v-list-item-group color="info" v-model="selectedGroupId">
                  <v-list-item
                    v-for="(item, itemIdx) in $store.getters[
                      'userGroup/getAllFromLatest'
                    ]"
                    :key="item.id"
                  >
                    <v-list-item-content @click="loadById(item.id, itemIdx)">
                      <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn x-small rounded fab class="mt-2" v-on="on" :disabled="item.name === 'Super Admin'">
                            <v-icon small>mdi-cogs</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="onEdit(item)" v-show="hasAccess('userGroup.edit')">
                            <v-list-item-title>
                              <v-icon small left>mdi-pencil</v-icon>Edit
                            </v-list-item-title>
                          </v-list-item>

                          <v-list-item @click="onDelete(item)" v-show="hasAccess('userGroup.delete')">
                            <v-list-item-title>
                              <v-icon small left>delete</v-icon>Delete
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="8" md="6">
          <v-card :loading="loading">
            <v-card-title>Users</v-card-title>
            <v-card-text style="max-height: 30vw; overflow: auto">
              <v-list>
                <v-list-item v-for="(user, idx) in listedUsers" :key="idx">
                  <v-icon>person</v-icon> {{ user.firstName }}
                  {{ user.lastName }} ({{ user.email }})</v-list-item
                >
              </v-list>
              <v-list v-show="listedUsers.length === 0">
                No user available
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card>
            <v-tabs v-model="tab" dense>
              <v-tabs-slider></v-tabs-slider>

              <v-tab> Permissions </v-tab>

              <v-tab> Backend </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">

              <v-tab-item>
                <v-row v-show="optional(detail, 'id', '')">
                  
                  <v-col>
                    <v-card :loading="loading">
                      <v-card-title>
                        {{ userGroup.single.name }}
                      </v-card-title>

                      <v-card-text>
                        <div
                          v-for="(frontendPermission, i) in frontendPermissions"
                          :key="`frontendPerm_${i}`"
                        >
                          <v-card class="mb-1">
                            <v-card-title
                              >{{ frontendPermission.label }}
                              <v-spacer />
                              <v-switch
                                v-model="frontendModelPermissions[frontendPermission.id]"
                                @change="checkAll($event, frontendPermission)"
                                label="Show Menu"
                                :readonly="isSuperAdmin"
                                color="blue"
                              />
                            </v-card-title>
                            <v-card-text class="d-flex" style="overflow:auto;">
                              <div
                                class="mr-5"
                                v-for="(
                                  faction, ii
                                ) in frontendPermission.actions"
                                :key="`${i}_faction_${ii}`"                                
                              >
                                <v-switch
                                  dense
                                  :label="faction.label"
                                  v-model="frontendModelPermissions[faction.id]"
                                  :readonly="isSuperAdmin"
                                  color="blue"
                                />
                              </div>
                            </v-card-text>
                          </v-card>
                        </div>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          @click="saveFrontendPermission"
                          color="info"
                          :disabled="!hasAccess('userGroup.edit') || isSuperAdmin"
                        >Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <v-row v-show="optional(detail, 'id', '')">
                  <v-col>
                    <v-card :loading="loading">
                      <v-card-title
                        >{{ userGroup.single.name }} Permissions</v-card-title
                      >
                      <v-card-text>
                        <v-simple-table class="pdf" width="100%">
                          <thead>
                            <tr>
                              <th></th>
                              <th
                                class="text-center"
                                v-for="feature in optional(
                                  actions,
                                  '0.features',
                                  []
                                )"
                                :key="feature.id"
                              >
                                {{ apexPermissionLabel(feature.name) }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="action in actions" :key="action.name">
                              <th>{{ action.name }}</th>
                              <td
                                class="text-center"
                                v-for="feature in action.features"
                                :key="feature.id"
                              >
                                <v-switch
                                  v-model="feature.access"
                                  class="shrink mr-0 mt-0"
                                  @change="
                                    updateAction(
                                      userGroup.single.id,
                                      feature.id,
                                      feature.actionId,
                                      $event
                                    )
                                  "
                                  dense
                                  :readonly="isSuperAdmin"
                                  color="blue"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <user-group-form
      :show="showForm"
      :item="selectedItem"
      @onClosed="clearAdd()"
    />

    <delete-dialog
      :show="showDelete"
      :item="selectedItem"
      @onClosed="clearDelete()"
      @onSucceded="refresh()"
    />
  </div>
  <NoPermission v-else />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import UserGroupForm from "./_userGroup/_Form";
import DeleteDialog from "./_userGroup/_Delete";
import formatterMixin from "@/mixins/formatterMixin";
import NoPermission from "components/NoPermission";

export default {
  mixins: [formatterMixin],
  components: {
    UserGroupForm,
    DeleteDialog,
    NoPermission
  },
  data() {
    return {
      page: "User Groups",
      showForm: false,
      showDelete: false,
      selectedItem: {},
      actionList: ["View", "Add", "Edit", "Delete"],
      actions: [],
      loading: false,
      selectedGroupId: 0,

      tab: null,

      frontendModelPermissions: {},

      frontendPermissions: [
        {
          label: "Dashboard",
          id: "dashboard",
          actions: [
            { id: "dashboard.view", label: "View All" },
          ],
        },
        {
          label: "Report",
          id: "report",
          actions: [
            { id: "report.view", label: "View All" },
          ],
        },
        {
          label: "Schedule",
          id: "schedule",
          actions: [
            { id: "schedule.view", label: "View All" },
            { id: "schedule.add", label: "Add" },
            { id: "schedule.edit", label: "Update" },
            { id: "schedule.delete", label: "Delete" },
          ],
        },
        {
          label: "Client",
          id: "client",
          actions: [
            { id: "client.view", label: "View All" },
            { id: "client.add", label: "Add" },            
            { id: "client.edit", label: "Update" },
            { id: "client.delete", label: "Delete" },
          ],
        },
        {
          label: "Announcement",
          id: "announcement",
          actions: [
            { id: "announcement.view", label: "View All" },
            { id: "announcement.add", label: "Add" },            
            { id: "announcement.edit", label: "Update" },
            { id: "announcement.delete", label: "Delete" },
          ],
        },
        {
          label: "Job",
          id: "task",
          actions: [
            { id: "task.view", label: "View All" },
            { id: "task.add", label: "Add" },            
            { id: "task.edit", label: "Update" },
            { id: "task.delete", label: "Delete" },
          ],
        },
        {
          label: "Time Clock",
          id: "timeClock",
          actions: [
            { id: "timeClock.view", label: "View All" },
            { id: "timeClock.add", label: "Add Manual Entry" },            
            { id: "timeClock.edit", label: "Update" },
            { id: "timeClock.delete", label: "Delete" },
            { id: "timeClock.start", label: "Start" },
            { id: "timeClock.stop", label: "Stop" },
            { id: "timeClock.complete", label: "Complete" },
          ],
        },
        {
          label: "Time Off",
          id: "timeOff",
          actions: [
            { id: "timeOff.view", label: "View All" },
            { id: "timeOff.add", label: "Add" },            
            { id: "timeOff.edit", label: "Update" },
            { id: "timeOff.delete", label: "Delete" },
          ],
        },
        {
          label: "Bid",
          id: "quote",
          actions: [
            { id: "quote.view", label: "View All" },
            { id: "quote.add", label: "Add" },            
            { id: "quote.edit", label: "Update" },
            { id: "quote.delete", label: "Delete" },
          ],
        },

        {
          label: "User",
          id: "user",
          actions: [
            { id: "user.view", label: "View All" },
            { id: "user.add", label: "Add" },            
            { id: "user.edit", label: "Update" },
            { id: "user.delete", label: "Delete" },
          ],
        },
        {
          label: "User Group",
          id: "userGroup",
          actions: [
            { id: "userGroup.view", label: "View All" },
            { id: "userGroup.add", label: "Add" },            
            { id: "userGroup.edit", label: "Update" },
            { id: "userGroup.delete", label: "Delete" },
          ],
        },
        {
          label: "Password Vault",
          id: "vault",
          actions: [
            { id: "vault.view", label: "View All" },
            { id: "vault.add", label: "Add" },            
            { id: "vault.edit", label: "Update" },
            { id: "vault.delete", label: "Delete" },
          ],
        },
        {
          label: "File Storage",
          id: "storage",
          actions: [
            { id: "storage.view", label: "View All" },
            { id: "storage.add", label: "Add" },            
            { id: "storage.edit", label: "Update" },
            { id: "storage.delete", label: "Delete" },
          ],
        },
      ],
    };
  },

  async mounted() {
    await this.getAll();
    await this.getAllUsers({
      PageSize: 1000,
    });
    await this.refresh();
  },

  watch: {
    frontendPerms(jsonPerms) {
      this.frontendModelPermissions = jsonPerms;
    },
    detail(n) {
      this.actions = this.actionList.map((actionName) => {
        let feats = n.permissions.map((perm) => {
          let found = this.getAccessByName(actionName, perm.featurePermissions);
          if (found) {
            return {
              id: perm.featureId,
              name: perm.featureName,
              actionId: found.actionId,
              access: found.access,
            };
          }
          return [];
        });
        return {
          name: actionName,
          features: feats,
        };
      });
    },
  },

  computed: {
    ...mapGetters(["userGroup/getAllFromLatest"]),
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      userGroup: (state) => state.userGroup,
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    data() {
      return this.userGroup.data;
    },
    detail() {
      return this.userGroup.single;
    },
    listedUsers() {
      return this.optional(this.user, "data", []).filter((user) => {
        return user.userGroupId == this.detail.id;
      });
    },
    frontendPerms() {
      if(this.isSuperAdmin) {
        return this.frontendPermissions.reduce((acc, x) => {
          acc[x.id] = true;
          x.actions.forEach(action => acc[action.id] = true);
          return acc;
        }, {});
      } else {
        let { frontEndPermissions } = this.detail;
        return frontEndPermissions ? JSON.parse(frontEndPermissions) : {};
      }
    },
    isSuperAdmin() {
      return this.detail?.name === "Super Admin";
    }
  },

  methods: {
    ...mapActions("userGroup", ["getAll", "changeAccess", "getById"]),
    ...mapActions({
      getAllUsers: "user/getAll",
      updateUserGroup: "userGroup/update",
    }),
    checkAll(value, x) {
      let list = x.actions.map((i) => {
        return i.id;
      });

      let frontendModelPermissions = this.frontendModelPermissions;
      let existingFrontendModelPermissions = {};

      for (const [key, value] of Object.entries(frontendModelPermissions)) {
        if (!list.includes(key)) {
          existingFrontendModelPermissions[key] = value;
        }
      }

      if (value) {
        list.map((action) => {
          existingFrontendModelPermissions[action] = value;
        });
      }      
      this.frontendModelPermissions = existingFrontendModelPermissions;
    },
    saveFrontendPermission() {
      this.updateUserGroup({
        ...this.detail,
        frontEndPermissions: JSON.stringify(this.frontendModelPermissions),
      });
    },

    getAccessByName(actionName, arr) {
      let found = arr.filter((a) => {
        return a.actionName === actionName;
      });
      if (found && found.length === 1) {
        return found[0];
      }
      return false;
    },
    updateAction(groupId, featureId, actionId, access) {
      let payload = {
        groupId,
        featureId,
        actionId,
        access,
      };
      this.changeAccess(payload);
    },

    async loadById(id, idx) {
      this.loading = true;
      await this.getById(id);
      this.selectedGroupId = idx;
      this.loading = false;
    },

    async refresh() {
      let firstGroupId = this.optional(this.userGroup, "data.0.id", 0, "");
      if (firstGroupId) {
        await this.loadById(firstGroupId, 0);
      }
    },

    // Rename general backend permissions to Apex-specific labels
    apexPermissionLabel(featureName) {
      if(featureName === "Task") {
        return "Job";
      } else if(featureName === "Quote") {
        return "Bid";
      } else {
        return featureName;
      }
    },

    onAdd() {
      this.showForm = true;
      this.selectedItem = {};
    },

    onEdit(item) {
      this.showForm = true;
      this.selectedItem = item;
    },

    onDelete(item) {
      this.showDelete = true;
      this.selectedItem = item;
    },

    clearAdd() {
      this.showForm = false;
      this.selectedItem = {};
    },

    clearDelete() {
      this.showDelete = false;
      this.selectedItem = {};
    },
  },
};
</script>